import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Цистерны';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h3>Цистерна 2-осная</h3>
                    <p>2-ох осная цистерна №7460000</p>
                    <p>Изготовлена в 1946 году на заводе имени Ильича, город Мореуполь</p>
                    <p>Предназначена для перевозки нефтепродуктов</p>
                    <p>Грузоподъемность - 20т</p>
                    <p>Тара - 11т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt084.jpg')} /></div>

                <div className="pageitem">
                    <h3>Цистерна 4-осная</h3>
                    <p>4-ох осная цистерна №746-0009</p>
                    <p>Изготовлена в 1934 году на Брянском машиностроительном заводе «Красный пролетарий»</p>
                    <p>Предназначена для перевозки нефтепродуктов</p>
                    <p>Грузоподъемность - 50т</p>
                    <p>Тара - 2т</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt085.jpg')} /></div>
            </div>
        </>
    );
}